<template>
  <div>
    <el-dialog
      :title="isImportContract ? '导入内部定额表' :'导入物资清单'"
      :visible.sync="isShow"
      :before-close="hideAddDialog"
      width="400px"
      :close-on-click-modal="false"
      style="text-align:center"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        action=""
        :data="uploadParam"
        :on-error="uploadFaildAction"
        :on-success="upLoadSuccessAction"
        :auto-upload="false"
        :http-request="customizeUpload"
        :on-change="fileChanged"
        :file-list="files"
        accept=".xls, .xlsx, .XLS, .XLSX"
        multiple
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="hideAddDialog">取 消</el-button>
        <el-button type="primary" @click="submitUpload">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible="ImportDataVisible" :before-close="hideDataDialog" width="66%" title="确认导入">
      <div class="confirmDia">
        <el-table
          ref="dataTable"
          :data="importData"
          highlight-current-row
          size="mini"
          border
          :close-on-click-modal="false"
        >
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="subCategoryNo" label="细目号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="subCategoryName" label="细目名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="type" label="类型" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="unit" label="单位" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="materialPrice" label="材料单价" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="materialCoefficient" label="材料系数" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="calculateFormula" label="计算公式" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="laborPrice" label="劳务单价" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="guideSignPrice" label="指导签约价" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="guideLaborPrice" label="指导劳务单价" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="opinion" label="本次修改意见" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="remarks" label="备注" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="checkInfo" label="导入标记" :show-overflow-tooltip="true"></el-table-column> -->
        </el-table>
        <!-- <el-table
          ref="dataTable"
          :data="importData"
          highlight-current-row
          size="mini"
          border
          v-else
        >
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="productNumber" label="存货编码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="productName" label="存货名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="model" label="规格型号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="factoryName" label="厂商" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="unitPrice" label="单价" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="checkInfo" label="导入标记" :show-overflow-tooltip="true"></el-table-column>
        </el-table> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hideDataDialog">取 消</el-button>
        <el-button type="primary" @click="submitUploadData">确认导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadOtherDetailsDictService, //导入内部定额表字典接口
  confirmexportOtherDetailsDictList, //确认导入内部定额表字典接口
  uploadmaterialDetailsDictService, //导入物资采购字典接口
  confirmexportmaterialDetailsDictList, //确认导入物资采购字典接口
  exportContractExcel
} from "../../../services/allContractServices";
export default {
  name: "uploadDialog",
  props: {
    isShow: {
      default: true,
      type: Boolean
    },
    isImportContract: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      uploadUrl: "",
      uploadParam: {},
      files: [],
      fileList: new FormData(),
      ImportDataVisible: false, //导入返回数据对话框可见性
      importData: [
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 },
        { subCategoryNo: 1 }
      ] //导入返回数据
    };
  },
  watch: {
    isShow(newValue) {
      if (!newValue) return;
      // this.uploadUrl = this.getUploadUrl();
      console.log(this.uploadUrl);
    }
  },
  methods: {
    hideAddDialog() {
      this.$emit("close");
      this.$refs.upload.clearFiles();
    },
    hideDataDialog() {
      this.ImportDataVisible = false;
      this.$emit("close");
      this.$refs.upload.clearFiles();
    },
    fileChanged(file, fileList) {
      console.log(file);
    },
    getUploadUrl() {
      return exportContractExcel();
    },
    //自定义上传事件
    customizeUpload(file) {
      console.log('customizeUpload', file);
      this.fileList = new FormData();
      this.fileList.append("file", file.file);
    },
    submitUpload() {
      this.$refs.upload.submit();
      this.importData = [];
      if (!this.fileList.get("file")) {
        this.$alert("请上传要导入的文件", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
        return

      }
      if (this.isImportContract) {
        //true为导入内部定额表 false 导入物资采购
        uploadOtherDetailsDictService(this.fileList)
          .then(data => {
            if (data.code == 10000000) {
              if (data.data.length > 0) {
                this.ImportDataVisible = true;
                this.importData = data.data;
                // this.$emit("saveImportItems", this.importData);
              }
            } else if (data.code >= 20000000) {
              this.$alert(data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          })
          .catch(error => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          });
      } else {
        uploadmaterialDetailsDictService(this.fileList)
          .then(data => {
            if (data.code == 10000000) {
              if (data.data.length > 0) {
                this.ImportDataVisible = true;
                this.importData = data.data;
                // this.$emit("saveImportItems", this.importData);
              }
            } else if (data.code >= 20000000) {
              this.$alert(data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          })
          .catch(error => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          });
      }
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    submitUploadData() {
      if (this.isImportContract) {
        //true为导入内部定额表 false 导入物资采购
        confirmexportOtherDetailsDictList(this.importData)
          .then(data => {
            if (data.code == 10000000) {
              this.importData = data.data;
              this.$alert("导入成功", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
              this.$emit("saveImportItems", this.importData);
              this.ImportDataVisible = false;
              this.hideDataDialog();
            } else if (data.code >= 20000000) {
              this.$alert(data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          })
          .catch(error => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          });
      } else {
        confirmexportmaterialDetailsDictList(this.importData)
          .then(data => {
            if (data.code == 10000000) {
              this.importData = data.data;
              this.$alert("导入成功", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
              this.$emit("saveImportItems", this.importData);
              this.hideDataDialog();
              this.ImportDataVisible = false;
            } else if (data.code >= 20000000) {
              this.$alert(data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          })
          .catch(error => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          });
      }
    },
    upLoadSuccessAction(response, file, fileList) {
      // if (response.resultCode == 0) {
      //   this.$message.success(response.msg);
      // } else {
      //   this.$message.error(response.msg);
      // }
      this.hideAddDialog();
    },
    uploadFaildAction(err, file, fileList) {
      this.$message.error(err.msg);
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

/deep/.el-upload {
  width: 100%;
}

/deep/.el-upload-dragger {
  width: 100%;
}
.confirmDia{
  height:480px;
  overflow:auto;
}
</style>